<template>
  <div class="consumptionRecord">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-field
            readonly
            :value="orderTypeStr"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('showConsumptionOrderType')"
            v-if="searchType == 1"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :value="orderStateStr"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('showConsumptionOrderState')"
            v-if="searchType == 2"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :value="paymentTypeStr"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('showConsumptionPaymentType')"
            v-if="searchType == 3"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <div class="custom-date" v-if="searchType == 4">
            <div class="date-btn1" @click="showStartDate">
              <span v-if="beginTime">{{ beginTime }}</span>
              <span v-else>{{ $t.meta.beginDate }}</span>
            </div>
            <div class="date-btn2" @click="showEndDate">
              <span v-if="endTime">{{ endTime }}</span>
              <span v-else>{{ $t.meta.endDate }}</span>
            </div>
            <van-button size="small" type="info" @click="onSearch">{{
              $t.meta.search
            }}</van-button>
          </div>
        </van-col>
        <van-col class="colItem2">
          <div @click="handleSheetShow">
            <span>{{ searchTypeStr }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.consumptionRecord.allOrderNumber }}：{{ item.C_AllOrderNumber }}
        </div>
        <div class="list-item">
          {{ $t.consumptionRecord.cOrderNumber }}：{{ item.C_OrderNumber }}
        </div>
        <div class="list-item">
          {{ $t.consumptionRecord.orderType }}：{{ item.OrderTypeStr }}
        </div>
        <div class="list-item">
          {{ $t.consumptionRecord.orderState }}：{{ item.OrderStateStr }}
        </div>
        <div class="list-item">
          {{ $t.consumptionRecord.paymentState }}：{{ item.PaymentTypeStr }}
        </div>
        <div class="list-item">
          {{ $t.consumptionRecord.totalAmount }}：{{ item.OrderTotalAmount }}
        </div>
        <div class="list-item">
          {{ $t.consumptionRecord.payAmount }}：{{ item.PayAmount }}
        </div>
        <div class="list-item">
          {{ $t.consumptionRecord.orderTime }}：{{ item.CreateTime }}
        </div>
        <div class="list-item" v-if="item.OrderActualPaymentDate">
          {{ $t.consumptionRecord.actualDate }}：{{ item.OrderActualPaymentDate }}
        </div>
        <div class="buttons" v-if="item.OrderState == 0">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="onPay(item)"
          >
            {{ $t.consumptionRecord.gotoPay }}
          </van-button>
        </div>
      </div>
    </van-list>

    <option-list
      event="showConsumptionOrderType"
      :options="typeList"
      @onSelect="onSelectType"
    ></option-list>

    <option-list
      event="showConsumptionOrderState"
      :options="stateList"
      @onSelect="onSelectState"
    ></option-list>

    <option-list
      event="showConsumptionPaymentType"
      :options="paymentList"
      @onSelect="onSelectPayment"
    ></option-list>

    <van-action-sheet
      :title="$t.meta.searchType"
      :closeable="false"
      v-model="sheetShow"
      :actions="sheetActions"
      @select="sheetSelect"
    />

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-dialog
      :title="$t.consumptionRecord.paymentTitle"
      width="90%"
      v-model="paymentVisible"
      @confirm="onCopy"
      @cancel="paymentVisible = false"
      :confirm-button-text="$t.meta.copy + $t.consumptionRecord.bankAccount"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="consumptionRecord-alert">
          <div style="margin-bottom: 10px">迎客商服控股（广州）有限公司</div>
          <div style="margin-bottom: 10px">
            {{ $t.consumptionRecord.bankName }}:
            中国工商银行股份有限公司广东自由贸易试验区南沙分行
          </div>
          <div style="margin-bottom: 10px">
            {{ $t.consumptionRecord.bankAccount }}: 0569 0920 0529 204
          </div>
          <div>{{ $t.consumptionRecord.hotline }}: 18820037803</div>
        </div>
      </slot>
    </van-dialog>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  DatetimePicker,
} from "vant";
import OptionList from "@components/optionList/OptionList.vue";
import { mapMutations } from "vuex";
import { SET_AUTH } from "@/store/mutation-types";
import { isAPP } from "@/plugins/environment/type.js";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(DatetimePicker);

export default {
  name: "consumptionRecord",
  components: {
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isApp: isAPP(),
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      typeList: [],
      stateList: [],
      paymentList: [],
      //filter
      searchType: 1,
      searchTypeStr: this.$t.consumptionRecord.orderType,
      orderType: null,
      orderTypeStr: "",
      orderState: null,
      orderStateStr: "",
      paymentType: null,
      paymentTypeStr: "",
      //操作菜单
      sheetShow: false,
      sheetActions: [],
      //日期
      selectDate: new Date(),
      beginTime: "",
      endTime: "",
      currentDate: "",
      showStartPicker: false,
      showEndPicker: false,
      //支付
      paymentVisible: false,
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    ...mapMutations([SET_AUTH]),
    onCopy() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: "0569 0920 0529 204",
        alertText: this.$t.meta.copySuccess,
      });
    },
    onPay(item) {
      if (item.PayAmount == 0) {
        this.paymentSuccess(item);
      } else {
        this.generatePayment(item);
      }
    },
    paymentSuccess(item) {
      this.$api.myHome
        .paymentSuccess({
          C_OrderNumber: item.C_OrderNumber,
          OrderType: item.OrderType,
        })
        .then(() => {
          this.getList();
        });
    },
    generatePayment(item) {
      this.$commonMethod.showLoading();
      var param = {
        C_OrderNumber: item.C_OrderNumber,
      };
      this.$api.user
        .generatePaymentLink(param)
        .then((res) => {
          var data = res.data;
          //支付宝 跳转（旧方法）
          // var result = encodeURIComponent(data);
          // this.$commonEnv.commonAction(this.$commonEnv.actionType.gotoPay, {
          //   url: "alipays://platformapi/startapp?appId=20000067&url=" + result,
          // });
          if (item.PaymentType == "1" || item.PaymentType == "2") {
            var param = {
              paymentMethod: item.PaymentType == "1" ? 2 : 1,
              linkUrl: data,
            };
            localStorage.setItem("payQrcode", JSON.stringify(param));
            this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
              isParams: false,
              path: "payQrcode",
              name: "payQrcode",
              query: [],
            });
          } else {
            //线下支付
            this.paymentVisible = true;
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onSelectType(item) {
      this.orderType = item.value;
      this.orderTypeStr = item.text;
    },
    onSelectState(item) {
      this.orderState = item.value;
      this.orderStateStr = item.text;
    },
    onSelectPayment(item) {
      this.paymentType = item.value;
      this.paymentTypeStr = item.text;
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    onShowEmit(emit) {
      this.typeList = [
        {
          text: this.$t.consumptionRecord.typeOption1,
          value: "1",
        },
        {
          text: this.$t.consumptionRecord.typeOption2,
          value: "2",
        },
        {
          text: this.$t.consumptionRecord.typeOption3,
          value: "3",
        },
      ];
      this.stateList = [
        {
          text: this.$t.consumptionRecord.stateOption1,
          value: "0",
        },
        {
          text: this.$t.consumptionRecord.stateOption2,
          value: "1",
        },
        {
          text: this.$t.consumptionRecord.stateOption3,
          value: "2",
        },
      ];
      this.paymentList = [
        {
          text: this.$t.consumptionRecord.paymentOption1,
          value: "1",
        },
        {
          text: this.$t.consumptionRecord.paymentOption2,
          value: "2",
        },
        {
          text: this.$t.consumptionRecord.paymentOption3,
          value: "3",
        },
      ];
      this.$bus.$emit(emit, true);
    },
    sheetSelect(e) {
      this.searchTypeStr = e.name;
      this.searchType = e.className;
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [
        { name: this.$t.consumptionRecord.orderType, className: "1" },
        { name: this.$t.consumptionRecord.orderState, className: "2" },
        { name: this.$t.consumptionRecord.methods, className: "3" },
        { name: this.$t.meta.date, className: "4" },
      ];
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        OrderType: this.searchType == 1 ? this.orderType : "",
        OrderState: this.searchType == 2 ? this.orderState : "",
        PaymentType: this.searchType == 3 ? this.paymentType : "",
        BeginTime: this.searchType == 4 ? this.beginTime : "",
        EndTime: this.searchType == 4 ? this.endTime : "",
      };
      this.$api.systemManagement
        .getCompanyOrderList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getUserInfo() {
      var param = {
        UserId: this.UserId,
      };
      this.$api.myHome
        .getUserInfo(param)
        .then((res) => {
          this.SET_AUTH(res.data);
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.consumptionRecord {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .van-cell {
          padding: 10px 0px 10px 20px;
        }
        .custom-date {
          padding: 10px 0px 10px 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
            width: 18%;
            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 12px;
      }
    }
  }
  .consumptionRecord-alert {
    overflow: scroll;
    padding: 20px;
    font-size: 14px;
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
}
</style>
